// Slice con las 3 capas del bracket resueltas por el server:
// { userId, real: {mid:row}, original: {mid:row}, effective: {mid:row} }
export default (state = null, action = {}) => {
  switch (action.type) {
    case 'BRACKET_VIEW_SET':
      return action.payload;
    default:
      return state;
  }
};
